import styled, { css } from 'styled-components';
import ArrowButton from 'Elements/Button/Arrow';
import NextImage from 'next/image';

export const Wrapper = styled.div`
    overflow: hidden;
    border-radius: 0.5rem;
`;

export const Content = styled.div`
    ${({ theme }) => css`
        position: relative;
        padding: 0.5rem 1rem 1rem 1rem;

        @media ${theme.breakpoints.medium.media} {
            padding: 1.8rem 1rem 1.8rem 2.5rem;
        }
    `}
`;

export const Container = styled.div`
    ${({ theme }) => css`
        display: flex;
        background: linear-gradient(
            ${theme.colors.campaigns.clearing.primary.hex} 0%,
            ${theme.colors.accents[30].hex} 100%
        );
        color: ${theme.colors.campaigns.clearing.primaryContrast.hex};
        border-radius: 0.5rem;
        flex-direction: column-reverse;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
        }
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-weight: 900;
        font-family: ${theme.fonts.secondary};
        margin-top: 0;
        text-transform: uppercase;
        font-size: 1.5rem;
        line-height: 1.1;

        @media ${theme.breakpoints.large.media} {
            font-size: 2rem;
        }
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        width: 100%;
        padding-top: 56.25%; /* 16:9 aspect ratio*/

        @media ${theme.breakpoints.medium.media} {
            padding-top: unset;
            height: auto;
            min-height: 100%;
        }

        @media ${theme.breakpoints.large.media} {
            min-width: 28rem;
        }
    `}
`;

export const StyledLandscapeImage = styled(NextImage)`
    ${({ theme }) => css`
        object-fit: cover;
        width: 100%;
        height: 100%;
        display: none;

        @media ${theme.breakpoints.medium.media} {
            object-position: left;
            display: block;
        }

        @media ${theme.breakpoints.large.media} {
            width: 100%;
            height: auto;
        }
    `}
`;

export const StyledPortraitImage = styled(NextImage)`
    ${({ theme }) => css`
        object-fit: contain;
        object-position: top;
        width: 100%;
        height: 100%;
        display: block;

        @media ${theme.breakpoints.medium.media} {
            display: none;
        }
    `}
`;

export const StyledArrowButton = styled(ArrowButton)`
    ${({ theme }) => css`
        && {
            @media ${theme.breakpoints.medium.media} {
                margin-top: 1rem;
            }
        }
    `}
`;
